var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTripPlan(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70.595,
    height: 69.943,
    viewBox: "0 0 70.595 69.943",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_196",
    "data-name": "Rectangle 196",
    width: 70.594,
    height: 69.943,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_Trip_Plan",
    "data-name": "icon_Trip Plan",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M0,14.7V58.14l22.4-5.914V9.489Z",
    transform: "translate(0 11.802)",
    fill: "#027b75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M11.293,52.226,32.574,57.44V15.358L11.293,9.489Z",
    transform: "translate(14.045 11.801)",
    fill: "#292625"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M22.182,15.357V57.438l20.826-5.214V9.489Z",
    transform: "translate(27.587 11.802)",
    fill: "#027b75"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M27.062,0a9.592,9.592,0,0,0-9.506,9.634c0,5.205,9.506,17.4,9.506,17.4s9.466-12.192,9.466-17.4A9.584,9.584,0,0,0,27.062,0m.2,13.478-4.088,2.149.7-4.631L20.7,7.815l4.546-.662,2.024-4.1,2.033,4.1,4.546.662L30.45,11l.913,4.631Z",
    transform: "translate(21.833 0.001)",
    fill: "#ffcb00"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTripPlan);
export default __webpack_public_path__ + "static/media/icon_Trip Plan.920f76f12e34fac1c0f2157eee3261f8.svg";
export { ForwardRef as ReactComponent };